import getIncidentCoord from './getIncidentCoord';

export default getIncidentCoord;
